import { render, staticRenderFns } from "./SegmentPublishPanel.vue?vue&type=template&id=774cb6f1&scoped=true"
import script from "./SegmentPublishPanel.vue?vue&type=script&lang=js"
export * from "./SegmentPublishPanel.vue?vue&type=script&lang=js"
import style0 from "./SegmentPublishPanel.vue?vue&type=style&index=0&id=774cb6f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774cb6f1",
  null
  
)

export default component.exports